import { Button } from '@mui/material';
import FormattedAlias from '@src/components/_shared/Translations/FormattedAlias';
import React, { Dispatch, SetStateAction } from 'react';

interface Props {
  setOpen: Dispatch<SetStateAction<boolean>>;
}

function CreateDevicesButton({ setOpen }: Props): React.ReactElement {
  const handleCreateDevicesClick = () => {
    setOpen(true);
  };

  return (
    <Button
      component='label'
      variant='contained'
      onClick={handleCreateDevicesClick}
    >
      <FormattedAlias id='Create Devices' />
    </Button>
  );
}

export default CreateDevicesButton;
